import { defineComponent as _defineComponent } from 'vue'
import { LibraryType } from '@/apis/bujianStore/types'
import { analyzeLayout } from '@/apis/work-shop'
import virtualList from '@/components/materialTable'
import store from '@/store'
import { matchMixPaibanPlan } from '@/util/common'
import { translate } from '@/util/commonFun'
import { buryPointApi } from '@/util/commonFuncs'
import { getPlankMatCode } from '@/util/plankCommonFuncs'
import { genOrderAddressInfo } from '@/util/plankCommonFuncs'
import { findStoreId } from '@/views/newPaiban/component/m-paiban-store/utlis'
import { Message } from 'element-ui'
import FileSaver from 'file-saver'
import { cloneDeep } from 'lodash'
import { nanoid } from 'nanoid'
import { computed, reactive, ref, watch } from 'vue'
import Vue from 'vue'
import XLSX from 'xlsx'
import XLSXStyle from 'xlsx-style-medalsoft'

import { bujianManageTableConfig } from '../config/tableConfig'
// import type { PartType } from '@/partTypes'
import type { PartType } from '../types/part'
import { initPart } from '../utils'

type List = (PartType & { id?: number })[]
type IIronwareData = {
  amount: number
  matSpec: string
  name: string
  type: string
  unit: string
}

interface IBujian {
  plank_data: PartType[]
  ironware_data: { [key in string]: IIronwareData } | undefined
}

export default /*#__PURE__*/_defineComponent({
  __name: 'm-bujian-table',
  props: {
    materialParts: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  // 料单板件数据
  materialParts: PartType[]
}

const texDirMap: Record<PartType['texDir'], string> = {
  normal: '竖纹',
  notcare: '无纹理',
  reverse: '横纹',
}



const state = reactive({
  show: true,
  isSelectAll: false,
  isLoading: false,
  isExport: false,
  tableBaseData: [] as List,
  tableFinalData: [] as List,
  stockKeys: [] as string[],
})
const samPleFormData = ref()

const selectPart = computed(() =>
  state.tableFinalData.filter((part) => part.isSelected)
)
// 获取IDS
const bujianIds = computed(() =>
  props.materialParts.map((part) => part.id).filter((id) => id)
)

// 数据变化则重新匹配
watch(
  () => props.materialParts,
  () => {
    dealResetFilterPart(props.materialParts)
  },
  {
    immediate: true,
  }
)

/** 高亮提示 */
function tip(str: string | number) {
  return `<i style=${'color:#18a8c7'}>${str}</i>`
}

// 原始的补件列表接口数据
let originData: any[] = []
/** 接口处理 */
// 获取列表 获取所有信息
function getBujianList() {
  state.isLoading = true
  Vue.prototype.$getByToken(
    '/workshop/supplements',
    {
      library_type: LibraryType.bujianStore, // 1
    },
    (res: { data: any; status: number; msg: string }) => {
      const { data, status, msg } = res
      if (status === 1) {
        originData = cloneDeep(data.data)
        data.data.forEach(
          (
            part: PartType & { size: string; plate_info: any; new: boolean }
          ) => {
            const {
              size,
              matCode,
              color,
              plKId,
              isHighlightMatCode,
              plankNum,
              new: _new,
            } = JSON.parse(part.plate_info)
            part.partUniqueId = nanoid()
            part.plankID = plKId
            part.size = size
            part.matCode = isHighlightMatCode
              ? matCode.includes('高光_')
                ? matCode
                : '高光_' + matCode
              : matCode
            part.texture = color
            part.plankNum = plankNum
            part.thick = size.split('*').slice(-1) ?? 0
            part.isSelected = store.state.bujianListChooseStatus.includes(
              part.id
            )
            part.new = _new ?? true
          }
        )
        state.tableBaseData = data.data
        dealFilterPart(state.tableBaseData)
        // 是否显示补件列表
        state.show = !!state.tableFinalData.length
      } else {
        Message.error(msg)
      }
      state.isLoading = false
    }
  )
}
getBujianList()
/**
 * 事件处理
 */
// 收起/展开
function onChangeTrigger(val: boolean) {
  store.commit('onChangeTrigger', val)
}
async function onExportBujianXlsxSheet() {
  if (!selectPart.value.length)
    return Message.error({
      center: true,
      message: translate('materialPage.suplement.exportTip'),
    })
  state.isExport = true
  const { plank_data, ironware_data } = await analyzeLayoutToPaiban(true)
  if (!plank_data.length) {
    state.isExport = false
    return
  }
  samPleFormData.value = genOrderAddressInfo(plank_data)
  genBujianTable(plank_data)
  genHardwareTable(ironware_data)
  state.isExport = false
  buryPointApi('material', 'bujian_list')
}
// 生成补件清单
function genBujianTable(bujianList: PartType[]) {
  const otherCel = bujianList
    .map((part) => {
      try {
        const ef = part?.edgeInfo?.split(/←|↓|→|↑/).filter((it) => it) ?? [
          0, 0, 0, 0,
        ]
        const edgeInfo = `左${ef[0]}下${ef[1]}右${ef[2]}上${ef[3]}`
        return [
          part.plankID,
          part.roomName ? part.roomName : ' ',
          part.wardrobeName,
          part.name ? part.name : ' ',
          `${part.thick ?? 0}${part.matCode ? part.matCode : ' '}`,
          part.texture ? part.texture : ' ',
          texDirMap[part.texDir],
          part.oRect.height,
          part.oRect.width,
          part.amount ?? 1,
          edgeInfo,
          part.hsInfo ?? `0孔0槽`,
          part.plankNum,
          part.remark,
        ]
      } catch (error) {
        console.warn('解析错误!')
        Message.warning({
          center: true,
          message: `id: ${part.id}解析错误`,
        })
        return
      }
    })
    .filter((it) => it)
  const tableHead = [
    '板号',
    '房间',
    '柜体',
    '名称',
    '板件类型',
    '颜色',
    '开料纹理',
    '下料高度',
    '下料宽度',
    '数量/块',
    '封边',
    '打孔开槽',
    '标签条码',
    '备注',
  ]
  otherCel.unshift(tableHead)
  genExportTable(otherCel as any, '补件拆单表', '补件板件拆单')
}
// 生成五金料单
function genHardwareTable(ironwareData: IBujian['ironware_data']) {
  if (!ironwareData) return
  const otherCel = []
  const ironwareDataKeys = Object.keys(ironwareData)
  ironwareDataKeys.forEach((key) => {
    const element = ironwareData[key]
    if (!element || element['name'] !== '连接件') return
    const arr: string[] = [
      element['name'],
      element['matSpec'],
      element['amount'] + '',
      element['unit'],
    ]
    otherCel.push(arr)
  })
  const tableHead = ['名称', '规格', '数量', '单位']
  otherCel.unshift(tableHead)
  genExportTable(otherCel, '补件五金拆单表', '补件五金拆单', {
    colNum: 4,
    colWidth: 14,
    fs: 9,
  })
}
// 生成导出表格
function genExportTable(
  tableData: (string | number)[][],
  tableName: string,
  fileName: string,
  style: {
    colNum: number
    colWidth: number
    fs: number
  } = {
    colNum: 14,
    colWidth: 5.5,
    fs: 9,
  }
) {
  // 创建 workbook
  const { address, clientData, orderRemark, factoryOrderNum, designer } =
    samPleFormData.value
  const wb = XLSX.utils.book_new()
  // 创建 worksheet
  const sheet = [
    [tableName],
    [`项目地址: ${address}`],
    [`工厂单号: ${factoryOrderNum}`],
    [`设计师: ${designer}`],
    ['测量日期:'],
    ['交货日期:'],
    [`客户名称: ${clientData}`],
    ['柜门投影面积:门板面积:'],
    [`订单备注: ${orderRemark}`],
    ...tableData,
  ]
  // 填充位置 这个是需要的
  for (let index = 0; index < 9; index++) {
    const target = sheet[index]
    target.push(...new Array(style.colNum - 1).fill(''))
  }
  const ws = XLSX.utils.aoa_to_sheet(sheet)
  // // 合并单元格
  ws['!merges'] = new Array(9).fill('').map((_, idx) => ({
    s: { r: idx, c: 0 },
    e: { r: idx, c: style.colNum - 1 },
  }))
  // 控制单元格宽度
  ws['!cols'] = new Array(14).fill({ wch: style.colWidth })
  const borderStyle = { style: 'thin', color: { rgb: '000000' } }
  const colStyle = {
    font: { sz: style.fs },
    border: {
      top: borderStyle,
      bottom: borderStyle,
      left: borderStyle,
      right: borderStyle,
    },
  }
  // 设置单元格样式
  XLSX.utils
    .sheet_to_json(ws, { header: 1 })
    .forEach((row: any, rowIndex: number) => {
      // 循环遍历每一列
      row.forEach((_: string, cellIndex: number) => {
        // 获取当前单元格的地址
        const cellAddress = XLSX.utils.encode_cell({
          r: rowIndex,
          c: cellIndex,
        })
        const cellStyle = ws[cellAddress].s ? ws[cellAddress].s : {}
        let centerStyle = {}
        // 第一行和其他板件数据文字居中
        if (rowIndex < 1 || rowIndex > 8) {
          centerStyle = {
            alignment: { horizontal: 'center', vertical: 'center' },
          }
        }
        ws[cellAddress].s = { ...colStyle, ...cellStyle, ...centerStyle }
      })
    })

  // 导出文件
  XLSX.utils.book_append_sheet(wb, ws, tableName)
  // 需要使用 xlsx-style 的 write 方法才可正常导出带有样式的文件
  const wbBuffer = XLSXStyle.write(wb, { type: 'buffer' })
  const blob = new Blob([wbBuffer], {
    type: 'application/octet-stream',
  })
  // 将 workbook 导出为 xlsx 文件
  FileSaver.saveAs(blob, `${fileName}.xlsx`)
}
// 处理选中
function onSelectChange(isAll: boolean, scope: any) {
  if (isAll) {
    store.commit('setBujianListChooseStatus', [])
    const arr = [...store.state.bujianListChooseStatus]
    state.tableFinalData.forEach((part) => {
      if (store.state.isSelectAll) {
        let dataStatus = part.id
        arr.push(dataStatus)
        store.commit('setBujianListChooseStatus', arr)
      } else {
        store.commit('setBujianListChooseStatus', [])
      }
      part.isSelected = store.state.isSelectAll
    })
  } else {
    let dataStatus = scope.part.id
    const arr = [...store.state.bujianListChooseStatus]
    let index = arr.findIndex((item: string) => item === dataStatus)
    index >= 0 ? arr.splice(index, 1) : arr.push(dataStatus)
    store.commit('setBujianListChooseStatus', arr)
    store.state.isSelectAll = state.tableFinalData.every(
      (part) => part.isSelected
    )
  }
}
/** 其他处理函数 */
function dealFilterPart(parts: PartType[]) {
  state.tableFinalData = parts.filter((part) => {
    const stockKey = `${part.texture}:${part.matCode}:${part.thick}`
    const plan = store.state.materialListStore?.selectedMixPaibanPlans?.find(
      (plan) => matchMixPaibanPlan(plan, part)
    )
    return (
      (state.stockKeys.includes(stockKey) || plan) &&
      !bujianIds.value.includes(part.id)
    )
  })
}
// 重新筛选可补件的板件
function dealResetFilterPart(parts: PartType[]) {
  const stockKeys: string[] = []
  parts.forEach((part) => {
    // const matCode = part.is_high_gloss_plank
    //   ? `高光_${part.matCode}`
    //   : part.matCode
    const matCode = getPlankMatCode(part)
    const stockKey1 = `${part.texture}:${matCode}:${part.thick}`
    const stockKey2 = `${part.oriTexture}:${part.matCode}:${part.thick}`
    if (!stockKeys.includes(stockKey1)) {
      stockKeys.push(stockKey1)
    }
    if (!stockKeys.includes(stockKey2)) {
      stockKeys.push(stockKey2)
    }
  })
  state.stockKeys = stockKeys
  dealFilterPart(state.tableBaseData)
}
// 解析数据
function analyzeLayoutToPaiban(isHardware = false): Promise<IBujian> {
  return new Promise((resolve, reject) => {
    const resultObj: IBujian = {
      plank_data: [],
      ironware_data: undefined,
    }
    if (!selectPart.value.length) {
      resolve(resultObj)
      return
    }
    // 此处传递选中的补件的原始数据
    const params = originData.filter((part) =>
      selectPart.value.some((it) => it.id === part.id)
    )
    analyzeLayout(params, isHardware)
      .then((result) => {
        if (result.status === 1) {
          const data = result.data.plank_data
          const alreadyUseId = new Set()
          data.forEach((part: PartType) => {
            initPart(part)
            part.amount = 1
            part.partUniqueId = nanoid()
            part.matCode = part.is_high_gloss_plank
              ? part.matCode.includes('高光_')
                ? part.matCode
                : '高光_' + part.matCode
              : part.matCode
            const target = findStoreId(selectPart.value, part, alreadyUseId)
            part.specHeight = part.specHeight ?? part.oRect.height
            part.specWidth = part.specWidth ?? part.oRect.width
            // 与柜柜直跳一致：补齐 srcTexDir，横纹标签尺寸才能还原为长*宽*厚
            part.srcTexDir = part.srcTexDir || part.texDir
            part._bujianStoreId = target.id
            part._isBujian = true
            part._isNewTableBujian = target?.new
            part._plankNum = part.plankNum
            // 海棠角/斜封边拉手补充 width，与开料清单 dealData 保持一致
            part.handleSlopes &&
              part.handleSlopes.forEach(
                (it) => ((it._conflict_uniqueId = nanoid()), (it.width = 10))
              )
          })
          alreadyUseId.clear()
          resultObj.plank_data = data
          resultObj.ironware_data = result.data.ironware_data
          resolve(resultObj)
        } else {
          resolve(resultObj)
          Message.error({
            center: true,
            message: '补件数据加载错误,无法参与本次排版！',
          })
          state.isExport = false
        }
      })
      .catch(() => {
        reject(resultObj)
        Message.error({
          center: true,
          message: '补件数据加载错误,无法参与本次排版！',
        })
        state.isExport = false
      })
  })
}

// 暴露重置函数和已选数据
expose({
  dealResetFilterPart,
  analyzeLayoutToPaiban,
  data: selectPart,
})

return { __sfc: true,texDirMap, props, state, samPleFormData, selectPart, bujianIds, tip, originData, getBujianList, onChangeTrigger, onExportBujianXlsxSheet, genBujianTable, genHardwareTable, genExportTable, onSelectChange, dealFilterPart, dealResetFilterPart, analyzeLayoutToPaiban, virtualList, store, bujianManageTableConfig }
}

})